<template>
  <el-dialog
    ref="viewDialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="h550_dialog abow_dialog"
    width="1100px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-form
      ref="dialogViewForm"
      :model="dialogViewForm"
      class="add-edit-view-form"
      @submit.native.prevent
    >
      <div class="modal-box">
        <h3 class="modal-title">
          基础信息
        </h3>
        <div class="modal-row-box">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="问题类型">
                <el-radio-group
                  v-model="dialogViewForm.type"
                  disabled
                >
                  <el-radio :label="2">
                    单选题
                  </el-radio>
                  <el-radio :label="3">
                    多选题
                  </el-radio>
                  <el-radio :label="4">
                    问答题
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-radio-group
                  v-model="dialogViewForm.status"
                  disabled
                >
                  <el-radio :label="1">
                    草稿
                  </el-radio>
                  <el-radio :label="2">
                    发布
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="问题内容(题干)">
                <el-input
                  v-model="dialogViewForm.question"
                  type="textarea"
                  :autosize="{minRows: 2}"
                  class="textarea-item"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-divider
            v-if="dialogViewForm.type === 2 || dialogViewForm.type === 3"
            content-position="left"
            class="divider-title"
          >
            <h5>问题选项</h5>
          </el-divider>
          <el-row :gutter="10">
            <el-col
              v-for="(item, index) in answerOptions"
              :key="index"
              :span="6"
              style="min-height: 36px; padding-left: 15px; font-size: 14px;"
            >
              <span>{{ item.optionValue }}. </span>
              <span style="padding-left: 5px;">{{ item.optionText }}</span>
              <span
                v-if="item.isAddToText === 1"
                style="color: red; padding-left: 5px;"
              >
                (需追加录入文本说明)
              </span>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="备注说明">
                <el-input
                  v-model="dialogViewForm.remark"
                  type="textarea"
                  disabled
                  style="margin-top: -8px;"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="modalClose">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>

// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { viewQuestionApi } from '@/api/v2/question'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      dialogViewForm: {},
      answerOptions: [],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {}
        _this.answerOptions = []
        _this.initQuestionData()

        _this.$nextTick(() => {

        })
      }
    }
  },
  methods: {
    // 初始化对象数据
    initQuestionData() {
      let _this = this;
      viewQuestionApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;

        // 设置修改前的选择题答案选项内容
        if (data.type === 2 || data.type === 3) {
          data.questionOptionDtoList.forEach(item => {
            _this.answerOptions.push(item)
          })
        }

      })
    },
    // 关闭弹框
    modalClose() {
      let _this = this;
      // 直接修改父组件的属性
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
.textarea-item {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
  }
}
::v-deep .el-form-item__error {
  left: 10px !important;
}
.tips-col {
  padding: 5px;
  min-height: 20px !important;
}
.button-col {
  text-align: right;
  min-height: 32px;
}
.divider-title {
  h5 {
    color: #409eff;
  }
}
</style>
